let apiUrl={
    "production":'https://cuploo-back-cuploo.vercel.app/',
    // "development":'https://cuploo-back-cuploo.vercel.app/',
    "development":"http://localhost:3000/"
}
const AppConstants={
    API_URL: apiUrl[process.env.NODE_ENV]
}
export default AppConstants; 